/** @format */

import React, { useState } from 'react';
import { Tabs, Tab, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { Button, Chip, Grid } from '@mui/material';
import clsx from 'clsx';
import { useStyles } from './style';
import { Icons } from 'components';

/**
 * این کامپوننت قدیمی استپر است - نسخه ای که بعد از ریفکتور داشتیم توی ضمانت نامه دچار باگ شده بود، این کامپوننت به نام اُلد اضافه شد
 */
const StepperKeeperOld = ({
  titles,
  panels,
  tabsErrors,
  formAction,
  onStepChanged = null,
  forceSelectedTabIndex = null,
  stepsToHideNext = [], // 0,1,2,...,steps-1
  stepsToHidePrevious = [], // 0,1,2,...,steps-1 //TODO: Reduce Opacity of unreachable indexes to inform user
  unreachableIndexes = [],
  onChangeTab,
  checkNextStepAllowed,
  ...rest
}) => {
  const classes = useStyles();
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const titlesLng = titles.length;

  const tabIndex = forceSelectedTabIndex != null ? forceSelectedTabIndex : activeTabIndex;

  const setTabIndex = onStepChanged ?? setActiveTabIndex;

  const handleSelect = async (targetIndex) => {
    if (unreachableIndexes?.includes(targetIndex)) return;
    if (targetIndex > tabIndex && stepsToHideNext?.includes(tabIndex)) return;
    if (targetIndex < tabIndex && stepsToHidePrevious?.includes(tabIndex)) return;
    if (onChangeTab) {
      onChangeTab(targetIndex);
    }

    if (typeof checkNextStepAllowed === 'function') {
      const valid = await checkNextStepAllowed(tabIndex);
      if (!valid) {
        return;
      }
    }

    if (unreachableIndexes?.includes[targetIndex]) return;
    if (targetIndex > tabIndex && stepsToHideNext?.includes(tabIndex)) return;
    if (targetIndex < tabIndex && stepsToHidePrevious?.includes(tabIndex)) return;
    setTabIndex(targetIndex);
  };

  return (
    <Tabs
      className={classes.root}
      forceRenderTabPanel
      {...rest}
      selectedIndex={tabIndex}
      onSelect={(index) => handleSelect(index)}
    >
      <TabList>
        {titles.map((tab, index) => (
          <Tab key={index}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Chip
                className={clsx(classes.chip, {
                  chipError: tabsErrors && tabsErrors?.[index],
                })}
                label={index + 1}
              />
              <span
                className={clsx(classes.stepTitle, {
                  hasError: tabsErrors && tabsErrors?.[index],
                })}
              >
                {tab.label}
              </span>

              {index + 1 !== titlesLng && (
                <div
                  className={clsx({
                    [classes.line]: true,
                    [classes.dashedLine]: tab?.liner,
                  })}
                />
              )}
            </div>
          </Tab>
        ))}
      </TabList>
      <div className={classes.panelsContainer}>
        {panels.map((v, k) => (
          <TabPanel key={k}>{v}</TabPanel>
        ))}
      </div>

      <Grid container item xs={12} className={classes.actionContainer} justifyContent="space-between">
        <Grid item>
          {tabIndex === 0 && !stepsToHideNext?.includes(tabIndex) ? (
            <Button
              variant="outlined"
              className={classes.stepperAction}
              startIcon={<Icons icon="CaretLeft" color="#2b3990" size="23" />}
              onClick={() => handleSelect(tabIndex + 1)}
            >
              {titles[1].label}
            </Button>
          ) : null}
          {tabIndex > 0 && (
            <>
              {!stepsToHidePrevious?.includes(tabIndex) && (
                <Button
                  variant="outlined"
                  className={classes.stepperAction}
                  startIcon={<Icons icon="CaretRight" color="#2b3990" size="23" />}
                  onClick={() => handleSelect(tabIndex - 1)}
                >
                  {titles[tabIndex - 1].label}
                </Button>
              )}
              {tabIndex < titlesLng - 1 && !stepsToHideNext?.includes(tabIndex) && (
                <Button
                  variant="outlined"
                  className={classes.stepperAction}
                  startIcon={<Icons icon="CaretLeft" color="#2b3990" size="23" />}
                  onClick={() => handleSelect(tabIndex + 1)}
                >
                  {titles[tabIndex + 1].label}
                </Button>
              )}
            </>
          )}
        </Grid>

        {formAction && (
          <Grid item >
            {formAction}
          </Grid>
        )}
      </Grid>
    </Tabs>
  );
};



export default StepperKeeperOld;
